module.exports = __webpack_public_path__ + "img/well-done.1874e2ed.svg";